import { Form } from '@arco-design/web-react';

import { CONTAINER_DEPLOY_INSTANCE_SCHEDULING_FIELD } from '../linkage/constants';

const FormItem = Form.Item;

function HiddenFormCollector() {
  return null;
}

/** 注册镜像 containerDeployConfig 联动 hidden 字段，确保 useWatch / 提交可收集 */
export function CiDeployConfigHiddenFields() {
  return (
    <FormItem field={CONTAINER_DEPLOY_INSTANCE_SCHEDULING_FIELD} hidden style={{ display: 'none', margin: 0 }}>
      <HiddenFormCollector />
    </FormItem>
  );
}
